import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useNewTrialState } from "../../pages/new-trail/hooks/NewTrialStateProvider";
import SoilAnalysisDrawer from "./SoilAnalysisDrawer";

interface SoilLayerComponentProps {
  readonly closeDrawer: () => void;
}

export function SoilLayerComponent({
  closeDrawer,
}: SoilLayerComponentProps): JSX.Element {
  const { setSoilOperationsData } = useNewTrialState();

  const handleSelectsImage = (imageData: any): void => {
    setSoilOperationsData(imageData);
  };
  return (
    <div
      className="soil-analysis-drawer-main field-operations-container"
      data-testid="soil-analysis-drawer"
    >
      <ErrorBoundary fallback={<span>Error loading soil analysis</span>}>
        <React.Suspense fallback="Loading...">
          <SoilAnalysisDrawer
            onSelectImage={handleSelectsImage}
            onCloseDrawer={closeDrawer}
          />
        </React.Suspense>
      </ErrorBoundary>
    </div>
  );
}
